import http from '@utils/http';

export const getLeaves = (params = {}) =>
    http.get('/hr/leave', { params }).then((res) => {
        const payload = res.data ?? {};
        let list = payload.data ?? payload;
        if (list && typeof list === 'object' && !Array.isArray(list) && Array.isArray(list.data)) {
            list = list.data;
        }
        const data = Array.isArray(list) ? list : [];
        return {
            data,
            total: payload.total ?? data.length,
            page: payload.page ?? 1,
            limit: payload.limit ?? 10,
            totalPages: payload.totalPages ?? 1,
        };
    });

export const getLeaveById = (id) =>
    http.get(`/hr/leave/${id}`).then((res) => res.data?.data ?? res.data);

export const createLeave = (data) =>
    http.post('/hr/leave', data).then((res) => res.data?.data ?? res.data);

export const approveLeave = (id) =>
    http.post(`/hr/leave/${id}/approve`).then((res) => res.data?.data ?? res.data);

export const rejectLeave = (id, reason) =>
    http.post(`/hr/leave/${id}/reject`, { reason }).then((res) => res.data?.data ?? res.data);

export const getLeaveTypes = () =>
    http.get('/hr/leave-types').then((res) => res.data?.data ?? res.data);

export const manageLeaveTypes = (data) =>
    http.post('/hr/leave-types', data).then((res) => res.data?.data ?? res.data);
